module.exports = __webpack_public_path__ + "img/3.dc6dd43a.png";